import React from 'react'

const FooterDivider = () => {
    return (
        <div className={`footer__divider`}/>
    )
}

export default FooterDivider